<div class="header">
  <div class="header-text">
    <h3 class="mat-h3"><ng-content></ng-content></h3>
  </div>
  <div class="header-button">
    <app-icon-button (onClick)="editClick()"></app-icon-button>
  </div>
</div>
